import { Container, ThemeProvider } from "@mui/material"
import { I18nextProvider } from "react-i18next"
import theme from "../../../helpers/theme"
import i18config from '../../../helpers/i18n'
import MembershipFeePayment from "../../../components/MembershipFeePayment/MembershipFeePayment"
import { useEffect, useState } from "react"
import MembershipPaymentSummary from "../../../components/MembershipPaymentSummary/MembershipPaymentSummary"
import { FeeResponse } from "../../../services/ntuc/memberService/payment"
import MembershipPaymentAcknowledgementPage from "../AcknowledgementPage/AcknowledgementPage"
import { MembershipPaymentRoute, MembershipPaymentRouteProps } from "../../membership-payment-flow/MembershipPaymentFlow/MembershipPaymentFlow"
import RetryUpfrontPayment from "../../../components/RetryUpfrontPayment/RetryUpfrontPayment"
import TermsAndConditionsPage from "../TermAndConditionPage/TermsAndConditionPage"
import { searchParams } from "../../../helpers/search-params"

type RouteParams = {
    fee: FeeResponse,
    membershipId?: number
}

enum ArrearsRoute {
    Main,
    RetryUpfrontPayment,
    MembershipFeePayment,
    MembershipPaymentSummary,
    Acknowledgement,
    TermsAndConditions
}

export type ArrearsRouteParams = {
    onNavigateTo: (newRoute: ArrearsRoute, routeParams?: RouteParams) => void
    routeParams?: RouteParams
}

interface ArrearsPaymentFlowRouteProps extends MembershipPaymentRouteProps {
    defaultRoute?: ArrearsRoute,
}

export type ArrearsRouteProps = {
    onNavigateTo: (newRoute: ArrearsRoute, routeParams?: RouteParams) => void
    routeParams?: RouteParams
}

const ArrearsPaymentFlow = (props: ArrearsPaymentFlowRouteProps) => {
    const [route, setRoute] = useState<ArrearsRoute>(props.defaultRoute ?? ArrearsRoute.MembershipFeePayment)
    const [routeParams, setRouteParams] = useState<RouteParams>()
    const { onNavigateTo: parentOnNavigateTo } = props

    const handleNavigateTo = (newRoute: ArrearsRoute, routeParams?: RouteParams) => {
        setRoute(newRoute)
        setRouteParams(routeParams)
    }

    useEffect(() => {
        if (window.myNtucConfig.membershipPaymentCallbackUrl != null
            && window.location.href.startsWith(window.myNtucConfig.membershipPaymentCallbackUrl)) {
            setRoute(ArrearsRoute.Acknowledgement)
        }
    }, [])

    useEffect(() => {
        const renewalCampaignCode = searchParams.renewal_campaign_code
        if(renewalCampaignCode) {
            window.myNtucConfig.renewalCampaignCode = renewalCampaignCode
        }
    }, [])

    const currentPage = () => {
        switch (route) {
            case ArrearsRoute.Main:
                parentOnNavigateTo(MembershipPaymentRoute.Main)
                break
            case ArrearsRoute.RetryUpfrontPayment:
                return <RetryUpfrontPayment onNavigateTo={parentOnNavigateTo} />
            case ArrearsRoute.MembershipFeePayment:
                return <MembershipFeePayment onNavigateTo={handleNavigateTo} routeParams={routeParams} />
            case ArrearsRoute.TermsAndConditions:
                return <TermsAndConditionsPage onNavigateTo={handleNavigateTo} routeParams={routeParams} />
            case ArrearsRoute.MembershipPaymentSummary:
                return <MembershipPaymentSummary onNavigateTo={handleNavigateTo} routeParams={routeParams} />
            case ArrearsRoute.Acknowledgement:
                return <MembershipPaymentAcknowledgementPage onNavigateTo={handleNavigateTo} />
        }
    }

    return (
        <I18nextProvider i18n={i18config}>
            <ThemeProvider theme={theme}>
                <Container id='main-container'>
                    {currentPage()}
                </Container>
            </ThemeProvider>
        </I18nextProvider>
    )
}

export default ArrearsPaymentFlow
export { ArrearsRoute }